module.exports = __webpack_public_path__ + "img/back_arrow.186eed45.png";